import React from "react";

function Logo({ tone }) {
  const isFooter = tone === "paper";
  return (
    <span className={"official-logo" + (isFooter ? " official-logo-footer" : "")}>
      <img
        src="/assets/brand/next-innovations-logo-horizontal-transparent.png"
        alt="NEXT INNOVATIONS"
        className="official-logo-img"
        width={601}
        height={151}
      />
    </span>
  );
}

export { Logo };
